import { __decorate } from "tslib";
import Vue from 'vue';
import Drawer from '@blade/common/components/paint/index.vue';
// import TaskPlayer from '@blade/common/components/task-management/player/task-player.vue';
// import TaskPlayer from '@blade-sxp/monitor/components/player/sei-player.vue';
import VideoPlayer from '@blade-sxp/monitor/components/player/simple-player.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import { isEmpty, isEqual } from 'lodash';
import calcPolygonCross from '@blade/common/utils/calcPolygonCross';
let VideoDrawer = class VideoDrawer extends Vue {
    rtspAddress;
    dataSource;
    buttons;
    roiType;
    showSelect;
    limits;
    isPlayFlag;
    directionConfig;
    paintState;
    options;
    isPlay;
    loading = true;
    // isPlay = true;
    styleProp;
    indexActive;
    showPoints;
    canvasStyle = {
        width: this.$props.styleProp.width | 0,
        height: this.$props.styleProp.height | 0,
    };
    oneRun = false;
    onchangeRtspAddress(val) {
        this.oneRun = false;
    }
    playVideo(val) {
        if (this.$refs.video) {
            if (this.isPlay) {
                this.$refs.video.play();
                this.loading = true;
            }
            else {
                this.loading = false;
                this.$refs.video.stop();
            }
        }
    }
    onchangeStyleProp(val, old) {
        if (!isEmpty(val)) {
            if (!isEqual(val, old)) {
                this.setCanvasStyle();
            }
        }
    }
    handelStopOrStart() {
        if (this.isPlay)
            this.$refs.video.stop();
        else {
            this.$refs.video.play();
            this.loading = true;
        }
        this.isPlay = !this.isPlay;
    }
    handlePlaying() {
        this.loading = false;
        this.$emit('playback-status', true);
        if (!this.oneRun) {
            this.setCanvasStyle();
            this.oneRun = true;
        }
    }
    setCanvasStyle() {
        const imgDom = this.$refs.video.$refs.video;
        const videoDom = imgDom.$refs.video;
        let videoWidth = videoDom.videoWidth;
        let videoHeight = videoDom.videoHeight;
        const wrapperRatio = this.styleProp.width / this.styleProp.height; // 容器宽高比
        const imageRatio = videoWidth / videoHeight; // 视频宽高比
        let canvasHeight = 0;
        let canvasWidth = 0;
        if (wrapperRatio < imageRatio) {
            canvasHeight = this.styleProp.width / imageRatio;
            canvasWidth = canvasHeight * imageRatio;
        }
        else if (wrapperRatio > imageRatio) {
            canvasWidth = this.styleProp.height * imageRatio;
            canvasHeight = canvasWidth / imageRatio;
        }
        else {
            canvasHeight = this.styleProp.height;
            canvasWidth = this.styleProp.width;
        }
        this.canvasStyle = {
            width: canvasWidth,
            height: canvasHeight,
        };
    }
    drawend(atlas) {
        if (!isEmpty(atlas)) {
            const canvasDom = this.$refs.simpleDrawer;
            atlas.forEach((item) => {
                const { vertices, id } = item;
                if (calcPolygonCross(vertices)) {
                    this.$message.error(`${this.$t('legitimateTip')}`);
                    this.$nextTick(() => {
                        canvasDom.deleteGraph(id);
                    });
                    this.$emit('cross-reset', true);
                }
                else {
                    this.$emit('cross-reset', false);
                }
            });
            this.$emit('drawend', atlas);
        }
        else {
            this.$emit('cross-reset', false);
            this.$emit('drawend', atlas);
        }
    }
    hover(graph) {
        // console.log('onHover:', graph);
        this.$emit('hover', graph);
    }
    noSelectDirection(atlas) {
        this.$emit('noSelectDirection', atlas);
    }
    get currPolygonPoints() {
        return MapPolygonsModule.currPolygonPoints;
    }
};
__decorate([
    Prop()
], VideoDrawer.prototype, "rtspAddress", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "dataSource", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "buttons", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "roiType", void 0);
__decorate([
    Prop({ default: true })
], VideoDrawer.prototype, "showSelect", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "limits", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "isPlayFlag", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "directionConfig", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "paintState", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "options", void 0);
__decorate([
    Prop({ default: true })
], VideoDrawer.prototype, "isPlay", void 0);
__decorate([
    Prop({
        type: Object,
        default: () => {
            return {
                width: 738,
                height: 415,
            };
        },
    })
], VideoDrawer.prototype, "styleProp", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "indexActive", void 0);
__decorate([
    Prop()
], VideoDrawer.prototype, "showPoints", void 0);
__decorate([
    Watch('rtspAddress')
], VideoDrawer.prototype, "onchangeRtspAddress", null);
__decorate([
    Watch('isPlay', { immediate: true })
], VideoDrawer.prototype, "playVideo", null);
__decorate([
    Watch('styleProp')
], VideoDrawer.prototype, "onchangeStyleProp", null);
VideoDrawer = __decorate([
    Component({
        name: 'DrawWithVideo',
        components: {
            Drawer,
            'video-player': VideoPlayer,
        },
        i18n: {
            messages: {
                en: {
                    legitimateTip: 'Please draw the ROI of compliance',
                },
                zh: {
                    legitimateTip: '请绘制合规的ROI',
                },
            },
        },
    })
], VideoDrawer);
export default VideoDrawer;
